import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const claimsApiService = {
    getClaimsFilterPagenated,
    getClaimsLatestUploadDocsFilterPagenated,
    getClaimsExcessCardPaymentsFilterPagenated,
    getClaimsSelectedRepairOptionsFilterPagenated,
    getTaskHistoryFilterPagenated,
    getSelectedClaim,
    setRelatedReference,
    updateClaims,
    approveClaim,
    approveClaimPreview,
    declineClaim,
    declineClaimEmailPreview,
    requestMoreDocs,
    requestMoreDocsEmailPreview,
    otherEmailPreview,
    otherEmail,
    refreshClaimant,
    setTaskFlags,
    setTaskFlagsForClaims,
    setTaskFlagsForClaimsDoc,
    setTaskFlagsForClaimsPay,
    setTaskFlagsForClaimsRep,
    getDocumentTypes,
    getDeclinationReasons,
    getManualStatuses,
    getResellers,
    getIncidentTypes,
    getRepairProviders,
    getRepairOptionTypes,
    getTaskTypes,
    getTaskTypesOutstanding,
    addClaimNote,
    addClaimNote2,
    getNotesForClaim,
    getEmailHistoryForClaim,
    getStatusHistoryForClaim,
    getPipelineRunHistoryForClaim,
    getDocumentsForClaim,
    getClaimsSelectedRepairOptionsForClaim,
    getGadgetPolicyForClaim,
    getTigaPolicyForClaim,
    importTigaPolicyForClaim,
    getPolFedPolicyForClaim,
    claimPaymentEmailPreview,
    claimPaymentEmail,
    getStatuses,
    getUnderwriters,
    getTaskHistoryForClaim,
    resetPolicyTiga,
    importTigaPolicyForClaim2,
    updateIncidentDate
}

function getClaimsFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/', payload)
}

function getClaimsLatestUploadDocsFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/recentdocuploads', payload)
}

function getClaimsExcessCardPaymentsFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/recentcardpayments', payload)
}

function getClaimsSelectedRepairOptionsFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/selectedrepairoptions', payload)
}

function getTaskHistoryFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/getTaskHistory', payload)
}

function getTaskHistoryForClaim(claimId) {
    return axios.get(baseUrl + '/api/admin/v1/claims/getTaskHistoryForClaim/' + claimId)
}

function getSelectedClaim(payload) {
    return axios.get(baseUrl + '/api/admin/v1/claims/' + payload )
}

function setRelatedReference(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateClaim', payload)
}

function updateClaims(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateClaims', payload)
}

function addClaimNote(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/addnote', payload)
}

function addClaimNote2(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/addnote2', payload)
}

function getNotesForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/getnotes', payload)
}

function setTaskFlags(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateTaskHistory', payload)
}

function setTaskFlagsForClaims(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateClaimsTaskHistory', payload)
}

function setTaskFlagsForClaimsDoc(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateClaimsTaskHistoryDoc', payload)
}

function setTaskFlagsForClaimsPay(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateClaimsTaskHistoryPay', payload)
}

function setTaskFlagsForClaimsRep(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/updateClaimsTaskHistoryRep', payload)
}

function approveClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/approve', payload )
}

function approveClaimPreview(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/approve/preview', payload)
}

function declineClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/decline', payload)
}

function declineClaimEmailPreview(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/decline/preview', payload)
}

function requestMoreDocs(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/requestdocs', payload)
}

function requestMoreDocsEmailPreview(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/requestdocs/preview', payload)
}

function otherEmailPreview(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/other/preview', payload)
}

function otherEmail(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/other', payload)
}

function refreshClaimant(payload) {
    return axios.get(baseUrl + '/api/admin/v1/claims/refreshClaimant/' + payload)
}

function getDocumentTypes() {
    return axios.get(baseUrl + '/api/admin/v1/document/gettypes')
}

function getDeclinationReasons() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getdeclinationreasons')
}

function getManualStatuses() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getmanualstatuses')
}

function getResellers() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getresellers')
}

function getUnderwriters() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getunderwriters')
}

function getIncidentTypes() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getincidenttypes')
}

function getRepairProviders() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getrepairproviders')
}

function getRepairOptionTypes() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getrepairoptiontypes')
}

function getTaskTypes() {
    return axios.get(baseUrl + '/api/admin/v1/claims/gettasktypes')
}

function getTaskTypesOutstanding(payload) {
    return axios.get(baseUrl + '/api/admin/v1/claims/gettasktypesforclaim/' + payload)
}

function getEmailHistoryForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/getemailhistory', payload)
}

function getStatusHistoryForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/getstatushistory', payload)
}

function getPipelineRunHistoryForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/getpipelinerunhistory', payload)
}

function getDocumentsForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/getdocuments', payload)
}

function getClaimsSelectedRepairOptionsForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/selectedrepairoptionsforclaim', payload)
}

function getGadgetPolicyForClaim(payload) {
    return axios.get(baseUrl + '/api/admin/v1/policy/getgadget/' + payload)
}

function getTigaPolicyForClaim(payload) {
    return axios.get(baseUrl + '/api/admin/v1/policy/gettiga/' + payload)
}

function getPolFedPolicyForClaim(payload) {
    return axios.get(baseUrl + '/api/admin/v1/policy/getpolfed/' + payload)
}

function importTigaPolicyForClaim(payload) {
    //let { claimId, policyId } = payload
    //return axios.get(baseUrl + '/api/admin/v1/policy/importtiga/' + claimId + '/' + policyId)

    return axios.post(baseUrl + '/api/admin/v1/policy/importtiga/', payload)
}

function importTigaPolicyForClaim2(payload) {
    return axios.post(baseUrl + '/api/admin/v1/policy/importtiga2/', payload)
}

function claimPaymentEmailPreview(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/claimpayment/preview', payload)
}

function claimPaymentEmail(payload) {
    return axios.post(baseUrl + '/api/admin/v1/claims/emails/claimpayment', payload)
}

function getStatuses() {
    return axios.get(baseUrl + '/api/admin/v1/claims/getstatuses/')
}

function resetPolicyTiga(policyId) {
    let params = { policyId }
    return axios.post(baseUrl + '/api/admin/v1/policy/resettiga/', params)
}

function updateIncidentDate(payload) {
    console.log('api: ', payload);
    return axios.post(baseUrl + '/api/admin/v1/UpdateClaim/UpdateIncidentDate', payload);
}